import Vue from 'vue';
import App from './app.vue';
import store from './store';
import {mapApiDynamicLoad} from './utils/map-api-helper';

Vue.config.productionTip = false;
Vue.config.devtools = true;

const mountApplication = (el: string) => {
    new Vue({
        el,
        store,
        render: (h) => h(App)
    });
};

const checkMapApiIsLoaded = function () {
    if (typeof google === 'object' && typeof google.maps === 'object') {
        if (process.env.NODE_ENV === 'development' && process.env.ALBUS_LOCAL_DEV === 'cypress') {
            require('../Styles/locations.scss');
            // @ts-ignore
            import('./tests/e2e/setup/')
                .then((setup) => setup.default())
                .then(() => new Promise((resolve) => setTimeout(resolve, 400))) // Wait a moment for dependencies to start up.
                .then(() => mountApplication('#app'), () => {
                    // Do nothing.
                });
        } else {
            mountApplication('#desktop-app');
        }
    } else {
        setTimeout(checkMapApiIsLoaded, 100);
    }
};

mapApiDynamicLoad();
checkMapApiIsLoaded();